export const IPV4_ACL_RULE_LIMIT = 756;

export const IPV4_ACL_PROTOCOL_OPTIONS = [
  { label: "Any", value: "any" },
  { label: "TCP", value: "tcp" },
  { label: "UDP", value: "udp" },
];

export const IPV4_ACL_POLICY_OPTIONS = [
  { label: "Deny", value: "deny" },
  { label: "Permit", value: "permit" },
];

export const IPV4_ACL_IP_MODE_OPTIONS = [
  { label: "Any", value: "any" },
  { label: "Specific", value: "specific" },
];

export const IPV4_ACL_PORT_MODE_OPTIONS = [
  { label: "Any", value: "any" },
  { label: "Specific", value: "manual" },
];
